module.exports = __webpack_public_path__ + "img/impactovisual.53d20306.png";